// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Search from "@insite/mobius/Icons/Search"; // Valtech Custom Code
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code */
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import { filtersProps } from "@store/Themes/common/props/filters";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import Search from "@toolkit/Library/Components/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Valtech Custom Code */

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    loaded: !!getProductListDataView(state).value,
    productFilters: state.pages.productList.productFilters,
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListSearchWithinStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    searchTextField?: TextFieldPresentationProps;
}

export const searchWithinStyles: ProductListSearchWithinStyles = {
    titleText: {
        ...filtersProps.title,
        forwardAs: "label",
    },
    searchTextField: {
        ...buttonGetFieldIconProps(Search),
        iconClickableProps: {
            css: css`
                background: none;
                color: ${getColor("primary")};
            `,
        },
        cssOverrides: {
            inputSelect: css`
                border-radius: ${pxToRem(24)};
                padding-left: ${pxToRem(15)};

                &:focus {
                    border-radius: ${pxToRem(24)};
                }
            `,
        },
    },
};

const styles = searchWithinStyles;

const ProductListSearchWithin: FC<Props> = ({ loaded, addProductFilters, productFilters }) => {
    /* Valtech Custom Code */
    const trackSearchFiltered = ga.use.trackSearchFiltered();
    const [searchText, setSearchText] = useState("");
    /* Valtech Custom Code */

    if (!loaded) {
        return null;
    }

    // Valtech Moved - searchText - up

    const doSearch = () => {
        if (searchText.trim() !== "") {
            addProductFilters({ searchWithinQueries: [searchText] });
            /* Valtech Custom Code */
            trackSearchFiltered({
                filter_name: "Search Within",
                filter_search_terms: searchText,
            });
            /* Valtech Custom Code */
        }
        setSearchText("");
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            doSearch();
        } else {
            setSearchText(event.currentTarget.value);
        }
    };

    let pageType: string;
    if (productFilters.pageProductLineId) {
        pageType = "Product Line";
    } else if (productFilters.pageBrandId) {
        pageType = "Brand";
    } else if (productFilters.pageCategoryId) {
        pageType = "Category";
    } else {
        pageType = "Results";
    }

    const label = translate(`Search Within ${pageType}`);

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="productList_searchWithin" /* Bunzl Custom Code */>
            <Typography
                {...styles.titleText}
                data-test-selector="productList_searchWithin_title" /* Bunzl Custom Code */
            >
                {label}
            </Typography>
            <TextField
                {...styles.searchTextField}
                /* Valtech Custom Code */
                iconClickableProps={{
                    ...styles.searchTextField?.iconClickableProps,
                    onClick: doSearch,
                    "aria-roledescription": label,
                }}
                /* Valtech Custom Code */
                value={searchText}
                onChange={event => setSearchText(event.currentTarget.value)}
                onKeyDown={handleKeyDown}
                placeholder={translate("Enter Keywords")}
                type="text"
                data-test-selector="productList_searchWithin_input" /* Bunzl Custom Code */
                id="productsKeywordSearch"
            />
        </StyledWrapper>
    );
    /* Valtech Custom Code */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSearchWithin),
    definition: {
        group: "Product List",
        displayName: "Search Within",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
